import { useRoutes } from "react-router-dom";
import WebsiteLayout from "../Pages/Website/Layout/Layout";
import LandingPage from "../Pages/Website/LandingPage/LandingPage";
import AboutUs from "../Pages/Website/AboutUs/AboutUs";
import Services from "../Pages/Website/ServicesPage/Services";
import Works from "../Pages/Website/Works/Works";
import Blogs from "../Pages/Website/Blogs/Blogs";
import Careers from "../Pages/Website/Careers/Careers";
import ContactUs from "../Pages/Website/ContactUs/ContactUs";
import AdminLayout from "../Pages/Admin/AdminLayout/AdminLayout";
import Dashboard from "../Pages/Admin/Dashboard/Dashboard";
import ServicesSection from "../Pages/Admin/ServicesSection/ServicesSection";
import UiUxService from "../Pages/Website/ServicesPage/UiUxService/UiUxService";
import WebDevelopmentService from "../Pages/Website/ServicesPage/WebDevelopment/WebDevelopment";
import DigitalMarketingService from "../Pages/Website/ServicesPage/DigitalMarketing/DigitalMarketing";
import AppDevelopmentService from "../Pages/Website/ServicesPage/AppDevelopment/AppDevelopment";
import Customers from "../Pages/Admin/Customers/Customers";
import Testimonial from "../Pages/Admin/Testimonial/Testimonial";
import UiUxDesign from "../Pages/Website/Careers/UiUxDesign/UiUxDesign";
import SoftwareDev from "../Pages/Website/Careers/SoftwareDeveloper/SoftwareDev";
import Marketing from "../Pages/Website/Careers/Marketing/Marketing";
import CustomerSupport from "../Pages/Website/Careers/CustomerSupport/CustomerSupport";
import Mahalakshmi from "../Pages/Website/Works/Mahalakshmi/Mahalakshmi";

const Routes = () => {
  const routes = useRoutes([
    {
      path: "/",
      element: <WebsiteLayout />,
      children: [
        {
          path: "/",
          element: <LandingPage />,
        },
        {
          path: "/aboutUs",
          element: <AboutUs />,
        },
        {
          path: "/services",
          element: <Services />,
        },
        {
          path: "/services/UiUxService",
          element: <UiUxService />,
        },
        {
          path: "/services/WebDevelopment",
          element: <WebDevelopmentService />,
        },
        {
          path: "/services/DigitalMarketing",
          element: <DigitalMarketingService />,
        },
        {
          path: "/services/AppDevelopment",
          element: <AppDevelopmentService />,
        },
        {
          path: "/works",
          element: <Works />,
        },
        {
          path: "/works/mahalakshmi",
          element: <Mahalakshmi />,
        },
        {
          path: "/careers",
          element: <Careers />,
        },
        {
          path: "/careers/ui-ux-designer",
          element: <UiUxDesign />,
        },
        {
          path: "/careers/software-developer",
          element: <SoftwareDev />,
        },
        {
          path: "/careers/digital-marketing-analyst",
          element: <Marketing />,
        },
        {
          path: "/careers/customer-support-specialist",
          element: <CustomerSupport />,
        },
        {
          path: "/blogs",
          element: <Blogs />,
        },
        {
          path: "/contactUs",
          element: <ContactUs />,
        },
      ],
    },
    {
      path: "/admin",
      element: <AdminLayout />,
      children: [
        {
          path: "/admin/dashboard",
          element: <Dashboard />,
        },
        {
          path: "/admin/services",
          element: <ServicesSection />,
        },
        {
          path: "/admin/customers",
          element: <Customers />,
        },
        {
          path: "/admin/testimonial",
          element: <Testimonial />,
        },
      ],
    },
  ]);

  return routes;
};

export default Routes;
